import React from 'react';
import './About.css';
import TechStack from '../TechStack/TechStack';

const About: React.FC = () => {
    return (
        <section id="about" className="about">
            <div className="container">
                <h2>About K9HKR Studios</h2>
                <div className="about-content">
                    <p>
                        K9HKR Studios is a cutting-edge development studio focused on creating innovative
                        web applications and digital solutions. We specialize in full-stack development
                        with a passion for clean code, modern technologies, and exceptional user experiences.
                    </p>
                    <p>
                        Our mission is to transform ideas into powerful, scalable applications that drive
                        business success and user engagement. From concept to deployment, we deliver
                        comprehensive solutions tailored to your unique needs.
                    </p>

                    <TechStack />
                </div>
            </div>
        </section>
    );
};

export default About;
